// export const getPreviewFormValues = (state) =>
//   state.lightEntrepreneurs.previewFormValues
// export const getOfferToPerson = (state) =>
//   state.lightEntrepreneurs.offerToPerson
export const lightEntre = (state) => state.lightEntrepreneurs.lightEntre
